import { logMessage } from 'utils/sentryUtils';

import * as BundleCountSVGs from './BundleCountSVGs';

const svgs = {
    2: BundleCountSVGs.twoPack,
    3: BundleCountSVGs.threePack,
    4: BundleCountSVGs.fourPack,
    5: BundleCountSVGs.fivePack,
    6: BundleCountSVGs.sixPack,
    7: BundleCountSVGs.sevenPack,
};

/**
 * @param {2|3|4|5|6|7} count - The number of items in a bundle
 * @returns
 */
function BundleCount({ className, count, width = 40, ...restProps }) {
    if (!count) {
        return null;
    }

    const Component = svgs[count];

    if (!Component) {
        logMessage('Bundle count SVG missing', { count, level: 'warning' });
    }

    return (
        <div className={className} {...restProps}>
            {Component && (
                <div aria-hidden="true">
                    <Component width={width} />
                </div>
            )}
            <div className="sr-only">Bundle of {count}.</div>
        </div>
    );
}

export default BundleCount;
